import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {teammateCanAccessInbox} from '../../../helpers/modelHelpers';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getFlatInboxes} from '../../../store/data/inboxes/inboxesSelectors';
import {getUser} from '../../../store/data/teammates/teammatesSelectors';
import {LensFormMultiSelectInboxes} from './lensFormMultiSelectInboxes';

/*
 * Props.
 */

interface LensFormMultiselectInboxesContainerProps {
  namespace: string | undefined;
}

/*
 * Selectors.
 */

function getNamespace(_state: AppState, props: LensFormMultiselectInboxesContainerProps) {
  return props.namespace;
}

/** Selects all inboxes that the user has access to. */
const getUserAccessibleInboxes = createSelector([getFlatInboxes, getUser], (inboxes, user) =>
  inboxes.filter((inbox) => teammateCanAccessInbox(user, inbox)),
);

/** Selects all available inbox choices for the given namespace. */
function makeGetChoices() {
  return createSelector([getUserAccessibleInboxes, getNamespace], (userAccessibleInboxes, namespace) =>
    namespace ? userAccessibleInboxes.filter((inbox) => namespace && inbox.namespace === namespace) : [],
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensFormMultiselectInboxesContainerProps>()(() => ({
  choices: makeGetChoices(),
}));

export const LensFormMultiSelectInboxesContainer = connect(mapStateToProps)(LensFormMultiSelectInboxes);
